module.exports = __webpack_public_path__ + "img/W7015-full.dc9742f6.jpg";